export const TICKET_CREATED_SUCCESSFULLY = 'ticketCreatedSuccessfully';
export const REGISTERED_SUCCESSFULLY = 'registeredSuccessfully';
export const ACCOUNT_ACTIVATED_SUCCESSFULLY = 'accountActivatedSuccessfully';
export const DEPOSIT = 'deposit';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/tracking/Events.ts